import React from "react";

import { type VariantProps, cv } from "~/tools/class-variance";

import GeckoLogo from "./assets/gecko.svg?react";
import SuseLogo from "./assets/logo.svg?react";

const variants = cv("w-auto max-w-full", {
	variants: {
		/**
		 * Text controls the color of the text.
		 * Fill controls the color of the gecko.
		 */
		variant: {
			"gecko-only": "fill-current text-[#30ba78]",
			// brand green for gecko + brand dark green for text
			brand: "fill-[#30ba78] text-[#0c322c]",
			// brand green for both gecko and text
			"brand-mono": "fill-current text-[#0c322c]",
			// brand green for gecko + white for text
			negate: "fill-[#30ba78] text-white",
			// white for both gecko and text
			"negate-mono": "fill-current text-white",
		},

		size: {
			xs: "h-4",
			sm: "h-6",
			md: "h-8",
			lg: "h-[72px]",
		},
	},

	defaultVariants: {
		variant: "brand",
		size: "md",
	},
});

export interface LogoProps extends VariantProps<typeof variants> {
	className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className, size, variant }) => {
	const Component = variant === "gecko-only" ? GeckoLogo : SuseLogo;

	return (
		<Component
			className={variants({ size, variant, className })}
			// without the height/width reset the svg does not stretch to fill the available space
			height={undefined}
			width={undefined}
		/>
	);
};
